import { useMemo } from "react";
import { useEarlyFreedomBaseline } from "web_myplann/Inspiration/EarlyFreedom/Hooks/useEarlyFreedomBaseline";
import type { EarlyFreedomInputs } from "web_myplann/Inspiration/EarlyFreedom/Types/EarlyFreedomTypes";
import { computeEarlyFreedomContext } from "web_myplann/Inspiration/EarlyFreedom/Utils/earlyFreedomMath";
import { useInspirationJourney } from "web_myplann/Inspiration/Hooks/useInspirationJourney";

export type EarlyFreedomSheet = "quick" | "income";

export const useEarlyFreedomJourney = () => {
	const { age, monthlySaving } = useEarlyFreedomBaseline();
	const { inputs, ...journey } = useInspirationJourney<
		EarlyFreedomInputs,
		EarlyFreedomSheet
	>({});

	const context = useMemo(
		() => computeEarlyFreedomContext(inputs, { age, monthlySaving }),
		[inputs, age, monthlySaving],
	);

	return { ...journey, context };
};
